var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSoundNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77812 0C8.14629 0 8.44478 0.29848 8.44478 0.666667V11.3333C8.44478 11.7015 8.14629 12 7.77812 12C7.40994 12 7.11145 11.7015 7.11145 11.3333V0.666667C7.11145 0.29848 7.40994 0 7.77812 0ZM4.22239 1.77795C4.59058 1.77795 4.88906 2.07643 4.88906 2.44462V9.55573C4.88906 9.92391 4.59058 10.2224 4.22239 10.2224C3.85421 10.2224 3.55573 9.92391 3.55573 9.55573V2.44462C3.55573 2.07643 3.85421 1.77795 4.22239 1.77795ZM1.33333 4.22221C1.33333 3.85402 1.03485 3.55554 0.666667 3.55554C0.29848 3.55554 0 3.85402 0 4.22221V7.77776C0 8.14594 0.29848 8.44443 0.666667 8.44443C1.03485 8.44443 1.33333 8.14594 1.33333 7.77776V4.22221ZM14.889 3.55554C15.2572 3.55554 15.5557 3.85402 15.5557 4.22221V7.77776C15.5557 8.14594 15.2572 8.44443 14.889 8.44443C14.5208 8.44443 14.2224 8.14594 14.2224 7.77776V4.22221C14.2224 3.85402 14.5208 3.55554 14.889 3.55554ZM12.0001 2.44462C12.0001 2.07643 11.7017 1.77795 11.3335 1.77795C10.9653 1.77795 10.6668 2.07643 10.6668 2.44462V9.55573C10.6668 9.92391 10.9653 10.2224 11.3335 10.2224C11.7017 10.2224 12.0001 9.92391 12.0001 9.55573V2.44462Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoundNegative);
export default __webpack_public_path__ + "static/media/icon_sound_negative.77605c5527e4ecc76ffe5a43923afef7.svg";
export { ForwardRef as ReactComponent };